import { contractContractSelector } from "common/_redux/contract/selector";
import ProcessTerminated from "common/components/process-terminated";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutEndStep } from "layout/_redux/actions";
import SideBar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect } from "react";

const ProcessoTerminato: React.FC = () => {
	const dispatch = useAppDispatch();

	const contract = useAppSelector(contractContractSelector);

	const handleClick = () => {
		window.location.href = "https://buffettifinance.com/";
	};

	useEffect(() => {
		dispatch(layoutEndStep(true));
	}, []);

	return (
		<div>
			<SideBar />
			<Topbar />
			<div className="container d-flex align-items-center min-vh-100">
				<ProcessTerminated
					title={
						<div>
							<p className="h2 sm-0 mb-2">Complimenti!</p>
							<p className="h2 mb-4">La prima fase del processo di OnBoarding si è conclusa!</p>
						</div>
					}
					text={
						<div>
							<p style={{ textAlign: "justify" }}>
								Stiamo effettuando le verifiche imposte dalle normative di settore. Il tuo codice
								pratica è <b>{contract?.codicePratica}</b>, il quale ti verrà mandato via mail.
								Questo è l'unico dato valido che dovrai comunicare per chiedere e/o ricevere
								informazioni sullo stato della pratica.
							</p>
						</div>
					}
					conclusione="A breve riceverai un' e-mail di aggiornamento sullo stato della pratica."
					button="Torna alla home"
					onClick={handleClick}
				/>
			</div>
		</div>
	);
};

export default ProcessoTerminato;
